export enum SortMode {
  default = 'Default',
  articleNameAsc = 'Article name (A-Z)',
  articleNameDesc = 'Article name (Z-A)',
  articleNumberAsc = 'Article number (Ascending)',
  articleNumberDesc = 'Article number (Descending)',
}
